import React, { useState } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const Row = ({ g }) => (
  <li data-testid={`admin-merge-row-${g.owner_id}-${g.book_id}`}>
    <strong>{g.email || g.owner_id}</strong> · {g.book_title} · {g.languages.join(' + ')} → keeps {g.base_lang} copy ·
    days kept {Object.entries(g.days_kept_per_copy).map(([l, n]) => `${l}:${n}`).join(', ')} → {g.days_kept_after} ·
    practices: {g.practices_kept.join(', ')}{g.practices_archived.length ? ` · archived: ${g.practices_archived.join(', ')}` : ''} ·
    {' '}{g.text_conflicts} text conflict(s) · {g.siddhi_versions} Siddhi version(s)
    {!g.safe && <span className="admin-error"> · NOT SAFE: {g.blockers.join('; ')}</span>}
    {g.status && <strong> · {g.status}</strong>}
  </li>
);

/* Admin: merge each user's language copies of a book into one journey. Dry run first; originals are backed up. */
export function MergeLanguagesTool({ token }) {
  const [data, setData] = useState(null);
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const auth = { headers: { Authorization: `Bearer ${token}` } };
  const run = async (apply) => {
    setBusy(true);
    setError('');
    try {
      const r = apply ? await axios.post(`${API}/api/admin/merge-languages`, {}, auth) : await axios.get(`${API}/api/admin/merge-languages`, auth);
      if (apply) setResult(r.data); else { setData(r.data); setResult(null); }
    } catch (e) {
      setError('Could not reach the server. Nothing was changed.');
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="admin-diagnostic-card admin-test-email" data-testid="admin-merge-card">
      <h3 className="admin-diagnostic-title">Merge language copies</h3>
      <p className="admin-diagnostic-help">One journey per book: finds readers who opened the same book in two languages and shows what merging would do. Check-in days are combined (each calendar day once), the earliest seal and the first copy&apos;s practices are kept, the most recently edited text shows and the other is kept, and every Siddhi version stays. Originals are backed up first.</p>
      <button className="admin-action-btn admin-refresh-btn" onClick={() => run(false)} disabled={busy} data-testid="admin-merge-preview-btn">
        {busy && !data ? <Loader2 className="admin-spinner" size={14} /> : null} Preview (dry run)
      </button>
      {error && <p className="admin-error" data-testid="admin-merge-error">{error}</p>}
      {data && (
        <>
          <p className="admin-diagnostic-help" data-testid="admin-merge-count">{data.count} book journey(s) to merge{data.unsafe ? `, ${data.unsafe} not safe (will be skipped)` : ''}.</p>
          <ul className="admin-diagnostic-meta" data-testid="admin-merge-preview">{data.groups.map((g) => <Row key={`${g.owner_id}-${g.book_id}`} g={g} />)}</ul>
          {data.count > data.unsafe && !result && (
            <button className="admin-action-btn admin-refresh-btn" onClick={() => run(true)} disabled={busy} data-testid="admin-merge-apply-btn">
              {busy ? <><Loader2 className="admin-spinner" size={14} /> Merging…</> : `Merge ${data.count - data.unsafe} journey(s)`}
            </button>
          )}
        </>
      )}
      {result && (
        <ul className="admin-diagnostic-meta" data-testid="admin-merge-result">
          {result.merged.map((g) => <Row key={`m-${g.owner_id}-${g.book_id}`} g={g} />)}
          <li><strong>Done.</strong> {result.merged.length} merged, {result.skipped_unsafe.length} skipped. Backup saved at {new Date(result.at).toLocaleString()}.</li>
        </ul>
      )}
    </div>
  );
}
